import {prop, head, filter, propEq, isEmpty, sum, map, allPass, all} from "ramda"
import { duration } from "./duration"
import * as R from "ramda"

window.R = R


export const insuranceRatePrice = async (rental) => {
    // calcula el precio diario de vip, duracion y total de vip
    /**
     * params:
     *  rental => obj =>  datos del rental
     * 
     * returns => obj => precio diario del vip y precio total basado en la duracion del tour
     */
    let vipItemPrice = 0
    const rentalDuration = duration(rental.booking.tour.effective_start_date, rental.booking.tour.effective_end_date, true)
    const rental_items = filter(propEq("rental_item_id", 1), rental.items.rows)
    const rental_item = filter(propEq("rental_item_type", 'insurance'), rental_items)

    if(!isEmpty(rental_item)){
        vipItemPrice = prop("price", head(rental_item))
    }
    const vipTotalPrice = vipItemPrice * rentalDuration
    return {dailyRate: vipItemPrice, vipTotalPrice}
} 

export const gpsRatePrice = async (rental) => {
    // calcula el precio diario de gps , duracion y total de gps
    /**
     * params:
     *  rental => obj =>  datos del rental
     * 
     * returns => obj => precio diario del gps y precio total basado en la duracion del tour
     */

    let gpsItemPrice = 0
    const rentalDuration = duration(rental.booking.tour.effective_start_date, rental.booking.tour.effective_end_date, true)
    if(rental.device.length > 0){
        gpsItemPrice = prop("price", head(filter(propEq("rental_item_type", "gps_device"), rental.items.rows)))
    }
    const gpsTotalPrice = gpsItemPrice * rentalDuration

    return {dailyRate: gpsItemPrice, gpsTotalPrice}
} 

const resolveTourVehicleModelId = (rental) => {
    const booking = rental && (rental.booking || rental.booking_info)
    if (booking && booking.vehicle_model_1 != null && booking.vehicle_model_1 !== "") {
        return Number(booking.vehicle_model_1)
    }
    if (rental && rental.vehicle_model_1 != null && rental.vehicle_model_1 !== "") {
        return Number(rental.vehicle_model_1)
    }
    if (rental && rental.vehicle_model_id != null && rental.vehicle_model_id !== "") {
        return Number(rental.vehicle_model_id)
    }
    return NaN
}

export const calcTotalTour = async (rental, prices, modelPrice, sumSuplements = true) =>{
    /**
     * calcula el precio total del tour en base al objeto rental
     * 
     * params:
     *  rental => obj => datos de rentals
     *  prices => arr => array con datos de los precios relacionados al tour
     *  modelPrice => int => precio de la moto seleccionada  
     *  sumSuplements => bool => indicador para agregar el monto de los suplementos al momento de hacer el calculo
     * 
     * returns: 
     *  => Obj => {totalCost(Float): costo total del rental, cancelInsuranceValue(Float): valor seguro de cancelacion}
     */
    console.log('rental', rental)
    const vehicleModelId = resolveTourVehicleModelId(rental)
    const priceRows = (prices && prices.prices && prices.prices.data) || []
    const tourPassengerListPrice = prop(
        "price",
        head(filter(propEq("price_item_sub_type", "tour_passenger"), priceRows))
    ) || 0
    if (vehicleModelId === 2) {
        prices.tourTotal = tourPassengerListPrice + 500
    }
    console.log('prices.tourTotal (tras ajuste modelo 2)', prices.tourTotal)

    console.log('calcTotalTour')
console.log('rental', rental.booking)

    let vipPrice = await insuranceRatePrice(rental)
    let gpsPrice = await gpsRatePrice(rental)
    let suplements = getTourSuplements(rental)
 
    console.log('modelPrice', modelPrice)
    
    let cancelInsuranceValue = 0
    if(rental.cancel_insurance.length > 0){
        const itemsPrices = prices.tourTotal + 
            prices.singlePrice + 
            prices.passengerPrice + 
            modelPrice + 
            gpsPrice.gpsTotalPrice 

        cancelInsuranceValue = parseFloat(((itemsPrices * 7.5) / 100).toFixed(2)) 
    }
    console.log('cancelInsuranceValue', cancelInsuranceValue)
    let totalCost = cancelInsuranceValue + (
        vipPrice.vipTotalPrice + 
        gpsPrice.gpsTotalPrice +
        prices.tourTotal + 
        prices.singlePrice + 
        prices.passengerPrice +
        modelPrice - rental.discount - 
        (rental.booking.reward_used ? rental.booking.rewards : 0)
    )
    console.log('totalCost', totalCost)
    if(sumSuplements){
        const totalCostSuplement = totalCost + suplements.payedSuplement + suplements.pendingSuplement
        console.log('totalCostSuplement', totalCostSuplement)
        return {totalCost: totalCostSuplement, cancelInsuranceValue}
    }
   
    console.log('cancelInsuranceValue', cancelInsuranceValue)
    return {totalCost, cancelInsuranceValue}
}

export const getTotalRefounded = (rental) => {
    /**Obtiene y retorna el total devuelto de un rental/tour 
     * 
     * args:
     * rental => Obj => datos de rentals
     * 
     * returns: 
     * float =>  total devuelto al rental
    */
    const charges = prop("charges", head(rental.payments))
    const totalRefunded =sum(
        map( prop("refunded_value"), filter( propEq("status", true), filter(propEq("to_refund", true), charges)))
    ) || 0;
    
    return parseFloat(totalRefunded.toFixed(2))
} 

export const calcTotalPayed = (rental) => {
    /**Obtiene y retorna el total pagado de un rental/tour 
     * 
     * args:
     * rental => Obj => datos de rentals
     * 
     * returns: 
     * float =>  total pagado del rental
    */
    const charges = prop("charges", head(rental.payments))
    const totalPayed = sum(map(prop("value"), filter(propEq("status", true), charges))) ;
    
    return parseFloat(totalPayed.toFixed(2))
}

export const getTourSuplements = (rental) => {
    /**obtiene y retorna los suplementos pagados y no pagados asociados a un tour 
     * args:
     * rental => Obj => datos de rentals
     * 
     * returns: 
     * Obj =>  suplementos pagados y suplementos no pagados {payedSuplements: (Float) , pendingSuplement: (Float)}
    */
    const charges = prop("charges", head(rental.payments))

    const pendingSuplement = sum(
        map(prop("value"), filter(allPass([propEq("status", false), propEq("extra_charge", true)]), charges))
    )

    const payedSuplement = sum(
        map(prop("value"), filter(allPass([propEq("status", true), propEq("extra_charge", true)]), charges))
    )

    return {
        payedSuplement: parseFloat(payedSuplement.toFixed(2)),
        pendingSuplement: parseFloat(pendingSuplement.toFixed(2)),
    }

}

export const calcTotalRemaining = (rental, tourTotalPrice) => {
     /**Obtiene y retorna el total que falta por cobrar de un rental/tour 
     * 
     * args:
     * rental => Obj => datos de rentals
     * tourTotalPrice = int => costo total del rental/tour
     * 
     * returns: 
     * float =>  total restante del rental
    */
    
    const totalRefunded = getTotalRefounded(rental)
    const totalPayed = calcTotalPayed(rental)
    // const suplements = getTourSuplements(rental)

    // const totalCost = rental.rental_price //cambiar por torTotalPrice
    const totalCost = tourTotalPrice
    // const usedRewards = (rental.booking.rewards == null) ? 0 : rental.booking.rewards
    // const discount = (rental.discount == null) ? 0 : rental.discount
    const tourCostAndSuplement = parseFloat(totalCost) 

    // const remaining = (tourCostAndSuplement - totalPayed) - discount - usedRewards + totalRefunded
    const remaining = (tourCostAndSuplement - totalPayed) + totalRefunded

    return parseFloat(remaining.toFixed(2))
}



// WEBPACK FOOTER //
// ./src/util/getPrice.js